import i18n from '@/i18n';

const configFormAddBlock = () => {
    return {
        configFieldTitleBlock: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingBlocksLP.titleBlock'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['required', 'max255']
        },
        configFieldCategoryBlock: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingBlocksLP.categoryBlock'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        }
    };
};

const configFormTitleFreeBlock = {
    configFieldTitle: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorField: i18n.t('landingPage.settingFreeBlock.title'),
        errorCustomMess: '',
        valueSync: '',
        typesValidate: ['required', 'max255']
    },
    configFieldSizeTitle: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorField: i18n.t('landingPage.setSizeText'),
        errorCustomMess: '',
        valueSync: '',
        typesValidate: ['max255']
    }
};

const configFormTitleButton = {
    configFieldTitle: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorField: i18n.t('landingPage.settingButtonBlock.titleBlock'),
        errorCustomMess: '',
        valueSync: '',
        typesValidate: ['required', 'max255']
    },
    configFieldTitleButton: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorField: i18n.t('landingPage.settingButtonBlock.titleButton'),
        errorCustomMess: '',
        valueSync: '',
        typesValidate: ['max255']
    },
    configFieldLink: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorField: i18n.t('landingPage.settingButtonBlock.link'),
        errorCustomMess: '',
        valueSync: '',
        typesValidate: ['max255', 'url']
    },
    configFieldColor: {
        type: 'color',
        classCustom: 'form-control-color',
        error: false
    }
};

export { configFormAddBlock, configFormTitleFreeBlock, configFormTitleButton };
